export default "__VITE_ASSET__cRLXWQ9A__"